import React from "react";
import Table from "@/components/ui/shared/table/Table";
import TableBody from "@/components/ui/shared/table/TableBody";
import TableRow from "@/components/ui/shared/table/TableRow";
import TableCell from "@/components/ui/shared/table/TableCell";
import TableHeader from "@/components/ui/shared/table/TableHeader";
import ScrollArea from "@/components/ui/shared/ScrollArea";
import clsx from "clsx";

interface TopAssistant {
  id: string
  name: string
  messageCount: number
  contactCount: number
  isActive: boolean
}

interface AssistentesTableProps {
  assistants: TopAssistant[]
  loading?: boolean
}

const AssistentesTable: React.FC<AssistentesTableProps> = ({ assistants, loading = false }) => {
  if (loading) {
    return (
      <div className="w-full flex gap-4 flex-col">
        <h1 className="text-[24px] font-semibold text-neutral-50">Assistentes</h1>
        <div className="w-full max-h-[300px] md:max-h-[350px] border-[1px] border-[#3F3F464D] rounded-[12px] bg-[#20202040] p-4">
          <div className="flex flex-col gap-4 animate-pulse">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="h-4 bg-neutral-600 rounded flex-1"></div>
                <div className="h-4 bg-neutral-600 rounded w-20"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex gap-4 flex-col ">
      <h1 className="text-[24px] font-semibold text-neutral-50">Assistentes</h1>
      <ScrollArea
        classNames={{
          root: "w-full  max-h-[300px] md:max-h-[350px] overflow-auto border-[1px] border-[#3F3F464D] rounded-[12px] bg-[#20202040]",
        }}
      >
        <Table className="min-w-[350px]">
          <TableHeader className="border-b-[1px] border-[#3F3F464D]">
            <TableRow>
              <TableCell className="text-neutral-50 font-semibold">
                <p className="py-2">Assistente</p>
              </TableCell>
              <TableCell className="text-neutral-50 font-semibold">Status</TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {assistants.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} className="text-center py-8">
                  <p className="text-neutral-400">Nenhum assistente encontrado</p>
                </TableCell>
              </TableRow>
            ) : (
              assistants.map((assistant) => {
                return (
                  <TableRow key={assistant.id}>
                    <TableCell>
                      <p className="py-1 font-medium">{assistant.name}</p>
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-1 flex-col">
                        <div className="flex justify-start items-center gap-2">
                          <div
                            className={clsx(
                              "w-[7px] h-[7px] rounded-full",
                              assistant.isActive ? "bg-green-500" : "bg-orange-400"
                            )}
                          ></div>
                          <p>{assistant.isActive ? "Ativo" : "Inativo"}</p>
                        </div>
                        <p className="text-xs text-neutral-400">
                          {assistant.contactCount} contatos
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  );
};

export default AssistentesTable;

export const AssistentesData = [
  {
    name: "SDR Prospecção",
    status: "active",
    value: "10 contatos",
  },
  {
    name: "SDR Prospecção",
    status: "in-active",
    value: "10 contatos",
  },
  {
    name: "SDR Prospecção",
    status: "in-active",
    value: "10 contatos",
  },
  {
    name: "SDR Prospecção",
    status: "in-active",
    value: "10 contatos",
  },
  {
    name: "SDR Prospecção",
    status: "active",
    value: "10 contatos",
  },
  {
    name: "SDR Prospecção",
    status: "active",
    value: "10 contatos",
  },
];
